import { defineStore } from 'pinia';

export const useMixPanelStore = defineStore('mixPanelStore', {
  state: () => {
    return {
      subtabSelected: null,
      eventNameTemplateLiteral: '',
      filterOptions: {
        pickupStates: null,
        deliveryStates: null,
        pickupZipRanges: null,
        deliveryZipRanges: null,
      },
      sortOptions: {
        sortByField: null,
        sortByDirection: null,
        previousSortByField: null,
        previousSortByDirection: null,
      },
      searchText: null,
    };
  },
  actions: {
    setSelectedSubtab(subtab) {
      this.subtabSelected = subtab;
    },
    setEventNameTemplateLiteral(eventName) {
      this.eventNameTemplateLiteral = eventName;
    },
    setFilterOptions(filterObj) {
      this.filterOptions = filterObj;
    },
    setSortOptions(sortObj) {
      this.sortOptions = sortObj;
    },
    setSearchText(searchText) {
      this.searchText = searchText;
    },
    fetchMixPanel(eventName, properties = {}) {
      const { trackEvent } = useAcvAnalytics();
      trackEvent(`lb2 ${this.eventNameTemplateLiteral} ${eventName}`, {
        ...this.mixPanelProperties,
        ...properties,
      });
    },
  },
  getters: {
    mixPanelProperties: (state) => {
      return {
        ...state.sortOptions,
        ...state.filterOptions,
        searchText: state.searchText,
        subtabSelected: state.subtabSelected,
      };
    },
  },
});
